module.exports = __webpack_public_path__ + "img/startupbangladeshlogo.11af9b33.png";